import {Component, OnInit, signal} from '@angular/core';
import {SortingComponent} from '../sorting.component';
import {PpeRequest} from '../ppe-request';
import {Router, RouterLink} from '@angular/router';
import {CordovaService} from '../cordova.service';
import {PpeService} from '../services/ppe.service';
import {LocalStorage} from '../storage.class';
import {User} from '../classes/user.class';
import {DatePipe, formatDate} from '@angular/common';
import {ConfirmDialogService} from '../services/confirm-dialog-service/confirm-dialog.service';
import {PpeStatus} from '../ppe-status';
import {AuthorisationService} from '../services/auth/authorisation.service';
import {VvrIconComponent} from "../vvr-icon/vvr-icon.component";
import {MatTooltip} from "@angular/material/tooltip";
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatFormField} from "@angular/material/input";
import {MatOption, MatSelect} from "@angular/material/select";
import {FormsModule} from "@angular/forms";
import {SortingIconComponent} from "../sorting-icon.component";
import {MatRipple} from "@angular/material/core";

@Component({
    selector: 'app-ppe-request',
    templateUrl: './ppe-request.component.html',
    styleUrls: ['./ppe-request.component.scss'],
    imports: [
        VvrIconComponent,
        MatTooltip,
        RouterLink,
        MatButton,
        MatFormField,
        MatSelect,
        MatOption,
        FormsModule,
        SortingIconComponent,
        DatePipe,
        MatIconButton,
        MatRipple
    ]
})
export class PpeRequestComponent extends SortingComponent<PpeRequest> implements OnInit {

    user: User;
    statusIds = [1, 2, 4, 8];
    readonly statusList = signal<PpeStatus[]>([]);
    showStatusFilter = true;

    constructor(
        private router: Router,
        private cordovaService: CordovaService,
        private confirmDialog: ConfirmDialogService,
        private ppeService: PpeService
    ) {
        super();
    }

    ngOnInit(): void {
        this.currentSort.update(() => 'created_at');
        this.desc.update(() => true);

        this.cordovaService.setBackbuttonAction(() => {
            this.router.navigate(['/']);
        });
        if (!AuthorisationService.hasFeature('pbmManagement')) {
            this.statusIds = [1, 2, 3, 4, 5, 6, 7, 8];
            this.showStatusFilter = false;
        }
        this.getData();
        this.user = LocalStorage.getUser();
        this.ppeService.statusList().subscribe(status => {
            this.statusList.set(status.data);
        });
    }

    public getData() {
        this.ppeService.listRequests(this.statusIds).subscribe(requests => {
            this.list.set(requests.data);
        });
    }

    delete(event, ppeRequest: PpeRequest) {
        event.stopPropagation();
        this.confirmDialog.confirm(
            'Aanvraag intrekken',
            `Weet u zeker dat u deze aanvraag aangemaakt op ${formatDate(ppeRequest.created_at, 'd MMM yyyy, H:mm', 'nl')} wilt intrekken?`,
            'Intrekken',
            'Behouden'
        ).then(() => {
            this.ppeService.deleteRequest(ppeRequest.id).subscribe(() => {
                const index = this.list().indexOf(ppeRequest);
                this.list().splice(index, 1);
            });
        }, () => {

        });
    }

}
